import { NavermapsProvider } from "react-naver-maps";
import { type MapsComponentporps } from "./types";
import { useEffect, useState } from "react";
import MapComponent from "./MapComponent";
import { LoadingOutlined } from "@ant-design/icons";

function Map(props: MapsComponentporps) {
  const [isLoading, setIsLoading] = useState(true);

  // Render Map only when window object is available (Compulsory)
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    <div className="pt-[100px] text-center">
      <LoadingOutlined />
    </div>;
  }

  return (
    <NavermapsProvider
      ncpClientId={
        process.env.NEXT_PUBLIC_NAVER_NPC_CLIENT_ID as unknown as string
      }
    >
      <MapComponent {...props} />
    </NavermapsProvider>
  );
}

export default Map;
